import React, { useState } from 'react';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';
import { showDateNoTime } from '@libs/NwMoment';

import { useUserPermission } from '@contexts/UserContext';

import { getModel } from '@hooks/API/Contact/UseContactsList';

import NwIcon from '@components/Gui/NwIcon';
import ModelInTownSchedulesDrawer from '@components/ModelInTown/ModelInTownSchedulesDrawer';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const InTownContainer = styled.div`
    font-weight: ${(props) => (props.isBold ? 'bold' : 'normal')};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;

    .icon-container {
        width: 0.75rem;
        text-align: center;
    }

    p {
        margin: 0;
    }

    small {
        font-weight: normal;
        font-size: 0.75rem;
    }
`;

const ModelInTown = ({ modelID, modelInTownSchedule, plainMode, readOnly }) => {
    const [drawer, setDrawer] = useState(false);
    const modelObject = getModel(modelID);
    const viewModelInTownSchedule = useUserPermission(
        'ViewModelInTownSchedule',
        modelObject && modelObject.U && modelObject.U.map((user) => user.UserID)
    );

    const getLocationPeriod = () => {
        if (!modelInTownSchedule.EndDate) {
            return `from ${showDateNoTime(modelInTownSchedule.StartDate)}`;
        }
        return `${showDateNoTime(modelInTownSchedule.StartDate)} > ${showDateNoTime(modelInTownSchedule.EndDate)}`;
    };

    const getModelInTown = () => {
        const todayDate = getMoment(new Date());

        if (!modelInTownSchedule) {
            return (
                <InTownContainer>
                    <div className="icon-container">
                        <NwIcon icon={byPrefixAndName.fasl['island-tropical']} />
                    </div>
                    <p>OUT</p>
                </InTownContainer>
            );
        }
        if (modelInTownSchedule && todayDate >= getMoment(modelInTownSchedule.StartDate)) {
            if (modelInTownSchedule.IsInTown) {
                if (!modelInTownSchedule.EndDate) {
                    return (
                        <InTownContainer isBold={true}>
                            <div className="icon-container">
                                <NwIcon icon={byPrefixAndName.fasl['location-smile']} />
                            </div>
                            <p>IN TOWN</p>
                        </InTownContainer>
                    );
                } else {
                    return (
                        <InTownContainer isBold={true}>
                            <div className="icon-container">
                                <NwIcon icon={byPrefixAndName.fasl['location-smile']} />
                            </div>
                            <p>
                                IN TOWN <small>until {showDateNoTime(modelInTownSchedule.EndDate)}</small>
                            </p>
                        </InTownContainer>
                    );
                }
            } else {
                return (
                    <InTownContainer>
                        <div className="icon-container">
                            <NwIcon icon={byPrefixAndName.fasl['island-tropical']} />
                        </div>
                        <p>
                            OUT <small>(in {modelInTownSchedule.Location})</small>
                        </p>
                    </InTownContainer>
                );
            }
        }
        if (modelInTownSchedule && todayDate < getMoment(modelInTownSchedule.StartDate)) {
            if (modelInTownSchedule.IsInTown) {
                return (
                    <InTownContainer>
                        <div className="icon-container">
                            <NwIcon icon={byPrefixAndName.fasl['island-tropical']} />
                        </div>
                        <p>
                            OUT <small>next arrival on {showDateNoTime(modelInTownSchedule.StartDate)}</small>
                        </p>
                    </InTownContainer>
                );
            } else {
                return (
                    <InTownContainer>
                        <div className="icon-container">
                            <NwIcon icon={byPrefixAndName.fasl['island-tropical']} />
                        </div>
                        <p>
                            OUT{' '}
                            <small>
                                in {modelInTownSchedule.Location} {getLocationPeriod()}
                            </small>
                        </p>
                    </InTownContainer>
                );
            }
        }
    };

    const handleOpenSchedulesDrawer = (event) => {
        event.stopPropagation();
        setDrawer(true);
    };

    return (
        <>
            <div
                className="header-body-boxes header-body-boxes-hoverable"
                onClick={!plainMode && viewModelInTownSchedule ? handleOpenSchedulesDrawer : null}
            >
                <PermissionBlock permission={viewModelInTownSchedule} content={getModelInTown()} />
            </div>
            {drawer && (
                <ModelInTownSchedulesDrawer readOnly={readOnly} modelID={modelID} onClose={() => setDrawer(false)} />
            )}
        </>
    );
};

export default ModelInTown;
